import { render, staticRenderFns } from "./synchronous.vue?vue&type=template&id=5e64045c&scoped=true&"
import script from "./synchronous.vue?vue&type=script&lang=js&"
export * from "./synchronous.vue?vue&type=script&lang=js&"
import style0 from "./synchronous.vue?vue&type=style&index=0&id=5e64045c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64045c",
  null
  
)

component.options.__file = "synchronous.vue"
export default component.exports